import { useState } from "react";
import DesktopNav from "../UI elements/DesktopNav";
import { TextField, useMediaQuery } from "@mui/material";
import DatePicker from "../UI elements/Datepicker";
import ChangePasswordModal from "../UI elements/ChangePasswordModal";
import { Link } from "react-router-dom";
import DeleteAccountModal from "../UI elements/DeleteAccountModal";
import axiosInstance from "../../../../../axiosInstance";
import dayjs from "dayjs";
import CalendarMonthIcon from "../../../../../Assets/Icons/CalendarMonthIcon.svg";

const DesktopView = (props) => {
  const [ChangesMade, setChangesMade] = useState(false);
  const [Name, setName] = useState(props.ProfileInfo.user.fullName);
  const [Email, setEmail] = useState(props.ProfileInfo.user.email);
  const [BirthDate, setBirthDate] = useState(props.ProfileInfo.birthDate);
  const [OverlayIsOpen, setOverlayIsOpen] = useState(false);
  const [PasswordModalIsOpen, setPasswordModalIsOpen] = useState(false);
  const [DeleteAccountIsOpne, setDeleteAccountIsOpen] = useState(false);
  const [Error, setError] = useState(""); // State to hold the error message

  const handleNameChange = (e) => {
    let Value = e.target.value;

    setChangesMade(true);
    setName(Value);

    if (!Value.trim()) {
      setError("Name is mandatory"); // Set error message if the field is empty
      setChangesMade(false); // to keep save button disabled
    } else {
      setError(""); // Clear error message if the field is not empty
    }
  };
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setChangesMade(true);
  };
  const saveBirthDate = (NewDate) => {
    setBirthDate(NewDate);
    setChangesMade(true);
  };

  const saveData = () => {
    let Req = {
      method: "POST",
      baseURL: window.localStorage.getItem("BaseURL") + "/api/account",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        login: Email,
        email: Email,
        fullName: Name,
        birthDate: BirthDate,
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);
        setChangesMade(false);
        props.UpdateProfileInfo();
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const toggleDeleteAccount = (Bool) => {
    setOverlayIsOpen(Bool);
    setDeleteAccountIsOpen(Bool);
  };
  const toggleChangePassword = (Bool) => {
    setOverlayIsOpen(Bool);
    setPasswordModalIsOpen(Bool);
  };

  const requestDeleteAccount = () => {
    let Req = {
      method: "DELETE",
      baseURL: window.localStorage.getItem("BaseURL") + "/api/account",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        window.localStorage.clear();
        window.location.assign("/");
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const isOlderThan13 = (dateString) => {
    // Calculate the date 13 years ago from today
    const date13YearsAgo = dayjs().subtract(13, "year");

    // Parse the input date
    const inputDate = dayjs(dateString);

    // Check if the input date is before the date 13 years ago
    return inputDate.isBefore(date13YearsAgo);
  };

  const returnSaveButtonClassName = () => {
    if (BirthDate !== undefined) {
      if (ChangesMade && isOlderThan13(BirthDate)) {
        return "action-btn save";
      } else {
        return "action-btn save disabled";
      }
    } else {
      if (ChangesMade) {
        return "action-btn save";
      } else {
        return "action-btn save disabled";
      }
    }
  };
  const isMobile = useMediaQuery("(max-width: 960px)"); // Detect if the screen is mobile

  const inputClasses = {
    "& .MuiOutlinedInput-root": {
      borderRadius: isMobile ? "4px 4px 0 0" : "15px",
      backgroundColor: isMobile ? "#F3EEE6" : "#fff1f2",
      border: "none",
      transition: "background-color 0.3s ease-in-out", // Smooth transition for background
      maxWidth: "450px !important", // Updated
      width: "100%",
      fontSize: "20px",
      paddingLeft: "10px",
      color: "#171717",
      fontWeight: 400,
    },

    "& .MuiOutlinedInput-root.Mui-focused": {
      backgroundColor: "#f8e0e0", // Change background on focus
    },

    "& .MuiOutlinedInput-notchedOutline": {
      border: "none !important", // Remove outline border
    },

    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },

    "& .MuiInputBase-input::placeholder": {
      color: "#1717174D", // Default placeholder color
      transition: "color 0.3s ease-in-out, opacity 0.3s ease-in-out", // Smooth placeholder animation
    },

    "& .MuiInputBase-input:focus::placeholder": {
      color: "#9e7676",
      opacity: 0.9,
    },
  };

  return (
    <div className="profile-wrapper">
      {OverlayIsOpen ? (
        <div
          className="overlay"
          onClick={() => {
            setOverlayIsOpen(false);
            setDeleteAccountIsOpen(false);
            setPasswordModalIsOpen(false);
          }}
        ></div>
      ) : null}
      {PasswordModalIsOpen ? (
        <ChangePasswordModal Close={() => toggleChangePassword(false)} />
      ) : null}
      {DeleteAccountIsOpne ? (
        <DeleteAccountModal
          Close={() => toggleDeleteAccount(false)}
          RequestDeleteAccount={() => requestDeleteAccount()}
        />
      ) : null}
      <DesktopNav
        SwitchTab={(IsCreditsTab) => props.SwitchTab(IsCreditsTab)}
        CreditsTabIsSelected={props.CreditsTabIsSelected}
      />
      <div className="form-wrapper">
        <div className="form-head">
          <h1>Personal information</h1>
          <section className="head-actions">
            <span className={"action-btn cancel"}>
              <Link to="/Home">Cancel</Link>
            </span>
            <span
              className={returnSaveButtonClassName()}
              onClick={() => saveData()}
            >
              Save
            </span>
          </section>
        </div>
        <main className="form-content">
          <TextField
            autoComplete="off" // Disable autofill
            fullWidth
            id="name"
            name="name"
            placeholder={"Name *"}
            variant="outlined"
            value={Name}
            onChange={handleNameChange}
            margin="normal"
            required // Make the field mandatory
            error={Boolean(Error)} // Show error state based on whether there is an error message
            helperText={Error} // Display error message below the field
            InputLabelProps={{ required: false }}
            sx={inputClasses}
          />
          <div className="datepicker-wrapper">
            <DatePicker
              Label={"Birth date"}
              DefaultValue={
                props.ProfileInfo.birthDate
                  ? props.ProfileInfo.birthDate
                  : new Date()
              }
              SaveNewDate={(Birthdate) => saveBirthDate(Birthdate)}
              style={{
                ...inputClasses,
                "& .MuiInputLabel-root": {
                  color: "#171717", // Label color
                  fontSize: "20px", // Label font size
                  fontWeight: 400, // Label font weight
                  marginLeft: "10px",
                },
                "& .MuiInputLabel-shrink, & .Mui-focused .MuiInputLabel-root": {
                  display: "none",
                },
              }}
              DatePickerProps={{
                slots: {
                  openPickerIcon: () => (
                    <img
                      src={CalendarMonthIcon}
                      alt="Calendar Icon"
                      style={{ width: 24, height: 24, marginRight: 10 }}
                    />
                  ),
                },
              }}
            />
            <p className="date-format-sub">MM/DD/YYYY</p>
          </div>
          <TextField
            autoComplete="off" // Disable autofill
            fullWidth
            id="email"
            name="email"
            disabled
            placeholder={"Email"}
            variant="outlined"
            value={Email}
            onChange={handleEmailChange}
            sx={{
              ...inputClasses,
              // Custom disabled styling
              "& .MuiInputBase-input.Mui-disabled": {
                color: "#171717", // Change text color
                WebkitTextFillColor: "#171717", // Override for Webkit browsers (e.g., Chrome)
              },
            }}
          />
          <p className="action-text action-text-top">
            To change your password{" "}
            <p className="trigger" onClick={() => toggleChangePassword(true)}>
              Click here
            </p>
          </p>
          <p className="action-text">
            To delete your account{" "}
            <p className="trigger" onClick={() => toggleDeleteAccount(true)}>
              Click here
            </p>
          </p>
        </main>
      </div>
    </div>
  );
};

export default DesktopView;
